var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from 'lodash.get';
import { isClientSide } from '../../utils/EnvironmentTest';
var TrackingProvider = /** @class */ (function () {
    function TrackingProvider() {
        this.isBrowser = isClientSide();
        // private dataLayer: ArgusEvent[] | any = [];
        this.dataLayer = [];
        this.currentPage = '';
        // Soasta Tracking Variables
        global.version = 'emma';
        global.emma = true;
        if (this.isBrowser && get(window, 'dataLayer')) {
            this.dataLayer = window.dataLayer;
        }
    }
    Object.defineProperty(TrackingProvider.prototype, "page", {
        set: function (value) {
            this.currentPage = value;
            if (value != null) {
                global.emma_pagegroup = value;
                if (value !== '') {
                    this.dataLayer.push({ Seitentyp: value.toLowerCase().replace('ks_', '') });
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    TrackingProvider.prototype.setLandmark = function (data, event) {
        if (event === void 0) { event = 'inspireEmma'; }
        this.fireLandmark(data, event);
    };
    TrackingProvider.prototype.fireLandmark = function (data, event) {
        var _a;
        if (event === void 0) { event = 'argusInspire'; }
        this.dataLayer.push({
            event: event,
            eventValue: __assign(__assign({}, data), { 
                // eslint-disable-next-line no-underscore-dangle
                sessionId: ((_a = global === null || global === void 0 ? void 0 : global._ec) === null || _a === void 0 ? void 0 : _a.sid) ? global._ec.sid : 'sid' }),
        });
    };
    return TrackingProvider;
}());
export var trackingProvider = new TrackingProvider();
export default trackingProvider;
//# sourceMappingURL=index.js.map